/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationMapIcon20Light = forwardRef('LocationMapIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.394 2.688a2 2 0 0 0-1.788 0L2.553 4.715A1 1 0 0 0 2 5.609v10.782a1 1 0 0 0 1.447.894L7.5 15.26l4.106 2.053a2 2 0 0 0 1.788 0l4.053-2.027a1 1 0 0 0 .553-.894V3.609a1 1 0 0 0-1.447-.894L12.5 4.74 8.394 2.688ZM3 16.391V5.609l4-2v10.782l-4 2Zm5-2V3.609l4 2v10.782l-4-2Zm9 0-4 2V5.609l4-2v10.782Z" })));
});
